export const environment = {
  production: false,
  enableMsal: false,
  msal: {
		clientId: '1c02660f-2a87-4251-9d24-78e97631d73f',
		logoutUri: 'https://dev.sitemanagement.xom.cloud',
		redirectUri: 'https://dev.sitemanagement.xom.cloud/callback',
		authority: 'https://login.microsoftonline.com/EMCloudAD.onmicrosoft.com',
		apiScopes: ['api://61fb07e0-bf3f-4f4d-81fd-a199b7e13d19/sitemanagement-dev/User'],
  },
  mapSettings: {
    mapOptions: {
      maxZoom: 22,
      minZoom: 0,
      zoomSnap: 0,
      zoomControl: false
    },
    startingZoom: 17,
    maxNativeZoom: 19
  },
  apiUrl: 'https://api.dev.sitemanagement.xom.cloud/api/',
};

